module.exports = __webpack_public_path__ + "media/images/wedding/top/hall-list/plan-wedding-lineup-kansai-4-703f3dc52624eed866c1b3981fae262a.png";